import {
  HOME_READ_SCHEDULING_RESULT_BEGIN,
  HOME_READ_SCHEDULING_RESULT_SUCCESS,
  HOME_READ_SCHEDULING_RESULT_FAILURE,
  HOME_READ_SCHEDULING_RESULT_DISMISS_ERROR,
} from './constants';

import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function readSchedulingResult(schedule) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_READ_SCHEDULING_RESULT_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
       axios.get("/api/Scheduling/"+schedule.id+"/ReadSchedulingResult",{id: schedule.id,
        seasonId:schedule.seasonId,
        description: schedule.description,
        creation: schedule.creation,
        scheduleAssignments: schedule.scheduleAssignments
      }).then(
        (res) => {
          dispatch({
            type: HOME_READ_SCHEDULING_RESULT_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          console.log({err});
          dispatch({
            type: HOME_READ_SCHEDULING_RESULT_FAILURE,
            data: { error: err.response && err.response.data && err.response.data.error, scheduleId: schedule.id },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissReadSchedulingResultError() {
  return {
    type: HOME_READ_SCHEDULING_RESULT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_READ_SCHEDULING_RESULT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        readSchedulingResultPending: true,
        readSchedulingResultError: null,
      };

    case HOME_READ_SCHEDULING_RESULT_SUCCESS:
      // The request is success
      return {
        ...state,
        schedules:
        {
          ...state.schedules,
          [action.data.id]: action.data
        },
        readSchedulingResultPending: false,
        readSchedulingResultError: null,
      };

    case HOME_READ_SCHEDULING_RESULT_FAILURE:
      // The request is failed
      return {
        ...state,
        schedules: {
          ...state.schedules,
          [action.data.scheduleId]: {
            ...state.schedules[action.data.scheduleId],
            pendingSchedulingId: "",
          }
        },
        readSchedulingResultPending: false,
        readSchedulingResultError: action.data.error,
      };

    case HOME_READ_SCHEDULING_RESULT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        readSchedulingResultError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/readSchedulingResult.js